import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './EnjoyVisit.css';
import { IDIcon } from '../../Icons/Icons';
import EventEmitter from '../../Utilities/EventEmitter'
import Fade from 'react-reveal/Fade';
import { setDigitalData } from '../../Utilities/Utils.js';

class EnjoyVisit extends Component {

    componentDidMount(){
        this.props.DGRBackgroundStore.showBlurAndHeader()
        
        if (this.props.DGRStore.debugMode === false){
            //REQUIRE USER 
            if (!this.props.DGRStore.values.lead_number){
                this.props.DGRStore.clearValues()
                return this.props.history.push('');
            }else{
                EventEmitter.emit('event:end_point_reached');
            }
        }
        setDigitalData( 'show myself around', this.props.DGRStore.club_number );
    }
    



    render(){

        var sizeObj = {
            fontSize: 130 
        }

		return (

                <div className="enjoyVisit">

			    <Fade>
                <div className="enjoyVisitBody">
                    <div className="dgrTitleText">
                        <h1>Enjoy your visit!</h1>
                    </div>
                    <div className="dgrTitleSubText">
                        <div className="subText">
                            Thank you for choosing 24 Hour Fitness
                        </div>
                    </div>
                    <div className="enjoyVisitBoxSpacer"></div>
                    <div className="enjoyVisitBox">
                        <div className="enjoyVisitIcon">
                        <IDIcon
                        nativeColor='#FFFFFF' className=""
                        style={sizeObj}
                        viewBox="0 0 179 108"
                        />
                        </div>
                        <div className="enjoyVisitBody">
                            Please show your ID to someone at the front desk and we’ll activate your pass
                        </div>
                    </div>
			    </div>
			    </Fade>
			    </div>
		)
		}
}

EnjoyVisit = inject('DGRStore', 'DGRBackgroundStore')(observer(EnjoyVisit))     
export default EnjoyVisit



// WEBPACK FOOTER //
// ./src/components/DGR/EnjoyVisit/EnjoyVisit.js